export default __webpack_public_path__ + "static/media/illustration-work-3-m@3x.c723d89c.webp";